@if (title) {
  <mat-toolbar class="doenkids-toolbar">
    @if (titleIcon) {
      <mat-icon class="title-icon">{{titleIcon}}</mat-icon>
    }
    <h2 class="display-3">{{title}}</h2>
    @if (query) {
      <div class="message">
        {{ 'sortable_list.result_count' | translate: {resultCount: list$?.length, query: query} }}
      </div>
    }
    <span class="flex-auto"></span>
    <ng-content select="[header]"></ng-content>
  </mat-toolbar>
}
@if (( listLoading | async )) {
  <mat-spinner class="loading-spinner" [diameter]="50"></mat-spinner>
}
<div class="mat-content animated fadeIn">
  @if (!( listLoading | async ) && list$ && fields) {
    <mat-card appearance="outlined" class="doenkids-filterable-list">
      <mat-card-content style="overflow: auto;">
        <ng-content></ng-content>
        <table matSort (matSortChange)="changeSortDirection($event)">
          <colgroup>
          @for (field of fields; track field) {
            @if (!(field?.hide) || !( field?.hide | async )) {
              <col
                [class.d-none]="field.hideLessThanMedium"
                [class.d-sm-block]="!field.hideLessThanSmall && field.hideLessThanMedium"
                [class.d-md-block]="field.hideLessThanMedium"
                [width]="field.width">
            }
          }
        </colgroup>
        <thead>
          <tr>
            @for (field of fields; track field) {
              @if (!(field?.hide) || !( field?.hide | async )) {
                <th
                  [class.d-none]="field.hideLessThanMedium"
                  [class.d-sm-table-cell]="!field.hideLessThanSmall && field.hideLessThanMedium"
                  [class.d-md-table-cell]="field.hideLessThanMedium"
                  style="display:table-cell"
                  [mat-sort-header]="field.field"
                  [disabled]="field.disableSort">
                  {{field.label}}
                </th>
              }
            }
          </tr>
        </thead>
        <tbody>
          <ng-container *ngTemplateOutlet="fieldItemsTemplate; context: {$implicit: list$}"></ng-container>
        </tbody>
      </table>
    </mat-card-content>
    @if (list$.length < metadata?.total) {
      <mat-card-actions>
        <pagination-controls
          [id]="id"
          [nextLabel]="'sortable_list.pagination.next' | translate"
          [previousLabel]="'sortable_list.pagination.previous' | translate "
          (pageChange)="paginate($event)"
        ></pagination-controls>
      </mat-card-actions>
    }
  </mat-card>
}
@if (!( listLoading | async ) && list$ && !fields) {
  <div>
    <ng-container *ngTemplateOutlet="fieldItemsTemplate; context: {$implicit: list$}"></ng-container>
    @if (list$.length < metadata?.total) {
      <pagination-controls
        [id]="id"
        [nextLabel]="'sortable_list.pagination.next' | translate"
        [previousLabel]="'sortable_list.pagination.previous' | translate"
        (pageChange)="paginate($event)"
      ></pagination-controls>
    }
  </div>
}
</div>
